import { Widget } from '@src/shared/ui/components/Widget';
import { React } from 'react';

/**
 * Optionally wrap content with widget component.
 *
 * @param children
 * @param widgetWrap
 * @returns {React.JSX.Element|*}
 * @constructor
 */
export function WithWidget({ children, widgetWrap }) {
  return widgetWrap ? (
    <Widget description="Entity action path statuses" title="In Queue">
      {children}
    </Widget>
  ) : (
    children
  );
}
